"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContestHeaderLayoutSmall = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var ContestFilterSelector_1 = require("./ContestFilterSelector");
var ContestTitle_1 = require("./ContestTitle");
var Countdown_1 = require("./Countdown");
var useContestHeaderLayoutSmallStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    headerWrapper: {
        display: "flex",
        flexDirection: "column",
        marginBottom: "8px",
        marginLeft: "16px",
        marginRight: "16px",
        marginTop: "8px",
        gap: theme.spacing.base * 2,
    },
    countdownWrapper: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginBottom: "16px",
    },
    endsInLabel: { fontSize: "10px", color: theme.colors.baseContrast050 },
}); });
var ContestHeaderLayoutSmall = function (_a) {
    var emitTrackingEvent = _a.emitTrackingEvent, onContestFilterChange = _a.onContestFilterChange, contestFilter = _a.contestFilter, contestInfo = _a.contestInfo, initialTimeRemaining = _a.initialTimeRemaining, isFallback = _a.isFallback, totalItemCount = _a.totalItemCount;
    var _b = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext, Contexts_1.IUserContext), 2), translate = _b[0].translate, user = _b[1];
    var classes = useContestHeaderLayoutSmallStyles();
    // Nothing to render without the contestInfo. Most likely there are no active contests
    if (!contestInfo) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes.headerWrapper, children: [(0, jsx_runtime_1.jsx)(ContestTitle_1.ContestTitle, { children: contestInfo.displayName }), !isFallback && ((0, jsx_runtime_1.jsxs)("div", { className: classes.countdownWrapper, children: [(0, jsx_runtime_1.jsx)("div", { className: classes.endsInLabel, children: translate("contest.ends_in") }), (0, jsx_runtime_1.jsx)(Countdown_1.Countdown, { initialTimeRemaining: initialTimeRemaining })] })), user.isAuthenticated && totalItemCount > 0 && !isFallback && ((0, jsx_runtime_1.jsx)(ContestFilterSelector_1.ContestFilterSelector, { emitTrackingEvent: emitTrackingEvent, onContestFilterChange: onContestFilterChange, contestFilter: contestFilter }))] }));
};
exports.ContestHeaderLayoutSmall = ContestHeaderLayoutSmall;
exports.ContestHeaderLayoutSmall.displayName = "ContestHeaderLayoutSmall";
//# sourceMappingURL=ContestHeaderLayout.small.js.map